import React from 'react';
import { forwardRef } from 'react';

const InputField = forwardRef(
	(
		{
			type = 'text',
			name,
			id,
			value = '',
			onChangeHandler,
			labelTitle,
			errors,
			withWrapper = true,
			withLabel = true,
			wrapperClassName = 'form-group',
			isDisabled = false,
			...props
		},
		ref
	) => {
		const inputElement = (
			<>
				{withLabel && labelTitle && <label htmlFor={id}>{labelTitle}</label>}
				<input
					ref={ref}
					type={type}
					autoComplete="off"
					name={name}
					id={id}
					value={value}
					onChange={onChangeHandler}
					disabled={isDisabled}
					{...props}
				/>
				{errors && <p className="error">{errors}</p>}
			</>
		);

		return withWrapper ? <div className={wrapperClassName}>{inputElement}</div> : inputElement;
	}
);

export default InputField;
